export const roleCoreClassifier = 'RoleCoreClassifier'
export const industryCoreClassifier = 'IndustryCoreClassifier'
export const companySizeCoreClassifier = 'CompanySizeCoreClassifier'
export const seniorityCoreClassifier = 'SeniorityCoreClassifier'

export const coreClassifierTypes = [
  roleCoreClassifier,
  industryCoreClassifier,
  companySizeCoreClassifier,
  seniorityCoreClassifier,
]
